import { Logger } from '@services/logger/abstract.logger';

export class DevLogger extends Logger {
    constructor() {
        super();
    }

    public get log() {
        return console.log.bind(console);
    }

    public get warn() {
        return console.warn.bind(console);
    }

    public get error() {
        return console.error.bind(console);
    }
}
